var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _pattern, _renderer, _player;
import { Player } from "./player";
export class Controller {
    constructor(pattern, renderer, cycleDuration) {
        _pattern.set(this, void 0);
        _renderer.set(this, void 0);
        _player.set(this, void 0);
        __classPrivateFieldSet(this, _pattern, pattern);
        __classPrivateFieldSet(this, _renderer, renderer);
        __classPrivateFieldSet(this, _player, new Player(pattern, cycleDuration));
        renderer.setController(this);
    }
    destroy() {
        __classPrivateFieldGet(this, _renderer).destroy();
    }
    setTimeScale(s) {
        __classPrivateFieldGet(this, _player).setTimeScale(s);
    }
    setHandSequence(seq) {
        __classPrivateFieldGet(this, _player).setHandSequence(seq);
    }
    setPaused(paused) {
        __classPrivateFieldGet(this, _player).setPaused(paused);
        __classPrivateFieldGet(this, _renderer).setPaused(paused);
    }
    setCadence(dwellF, shiftF) {
        __classPrivateFieldGet(this, _player).setCadence(dwellF, shiftF);
    }
    onFrame(renderer, timestamp) {
        return __classPrivateFieldGet(this, _player).beat(timestamp);
    }
    zoomToFit() {
        const bbox = __classPrivateFieldGet(this, _player).getBoundingBox();
        __classPrivateFieldGet(this, _renderer).zoomToFit(bbox);
    }
}
_pattern = new WeakMap(), _renderer = new WeakMap(), _player = new WeakMap();
